import { EMPLOYER_HELP_CENTRE_URL } from '@seek/shared-constants';

import { TRACKING_CODES } from 'src/shared/constant';
import type { SuggestionType } from 'src/shared/types';

export const TEMPLATE_SUGGESTION: SuggestionType = {
  message:
    'Job ad templates have recently been retired. For more details head over to our %link',
  variables: {
    link: {
      label: 'Help Center',
      href: 'article/Job-ad-templates-are-being-retired',
      site: EMPLOYER_HELP_CENTRE_URL,
      product: 'other',
      tracking: TRACKING_CODES.content_element_pressed,
    },
  },
};

export const MFA_SUGGESTION: SuggestionType = {
  message:
    'Having trouble logging into your SEEK account? Visit our %link for information about accessing your account, including account verification',
  variables: {
    link: {
      label: 'Help Center',
      href: '',
      site: EMPLOYER_HELP_CENTRE_URL,
      product: 'other',
      tracking: TRACKING_CODES.content_element_pressed,
    },
  },
};

export const INTEGRATION_SUGGESTION: SuggestionType = {
  message:
    'If you wish to connect your SEEK Account to your Recruitment Software Provider, visit %link',
  variables: {
    link: {
      label: 'Link your software',
      href: '/partners/link-your-software/',
      tracking: TRACKING_CODES.link_your_software_link_clicked,
    },
  },
};
